import { ChangeEvent, useEffect, useState } from "react";
import styles from "./index.module.scss";

interface TextFieldProps {
    name: string;
    inputValue: string;
    inputLabel: string;
    inputType?: "text" | "url";
    isBold?: boolean;
    placeholder?: string;
    onChange: (name: string, value: any) => void;
}

const TextField = ({ name, inputValue, inputLabel, inputType = "text", isBold = false, placeholder, onChange }: TextFieldProps) => {
    const [value, setValue] = useState("");

    useEffect(() => {
        inputValue && setValue(inputValue)
    }, [inputValue]);

    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        const newValue = e.target.value;
        setValue(newValue);

        if (newValue.trim() !== value.trim()) {
            onChange(name, newValue);
        }
    };
    return (
        <div className={styles.inputContainer}>
            <label htmlFor={name} className={styles.label}>{inputLabel}</label>
            <input
                id={name}
                type={inputType}
                value={value}
                onChange={handleChange}
                placeholder={placeholder}
                className={`${styles.input} ${isBold ? styles.bold : ""}`}
            />
        </div>
    );
};

export default TextField;